module.exports = __webpack_public_path__ + "static/img/link_young_employee_long.058853a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/link_young_employee_long.svg
// module id = STDq
// module chunks = 0